/**
 * Articles & Podcasts Video Carousel - Pure Tailwind Version
 * Enhanced animations and functionality
 */

(function() {
  'use strict';
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Check if section exists
    const sections = document.querySelectorAll('.articles-podcasts-section');
    
    if (sections.length === 0) {
      return;
    }
    
    initScrollAnimations();
    initVideoCarousel();
    initVideoControls();
    initArticleCards();
  }
  
  function initScrollAnimations() {
    // Trigger animations when section comes into view
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const section = entry.target;
            
            // Trigger fade animations
            const fadeUpElements = section.querySelectorAll('.animate-fade-up');
            const fadeRightElements = section.querySelectorAll('.animate-fade-right');
            const fadeLeftElements = section.querySelectorAll('.animate-fade-left');
            
            fadeUpElements.forEach(function(el) {
              el.style.animationPlayState = 'running';
            });
            
            setTimeout(function() {
              fadeRightElements.forEach(function(el) {
                el.style.animationPlayState = 'running';
              });
            }, 200);
            
            setTimeout(function() {
              fadeLeftElements.forEach(function(el) {
                el.style.animationPlayState = 'running';
              });
            }, 400);
            
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      
      document.querySelectorAll('.articles-podcasts-section').forEach(function(section) {
        observer.observe(section);
      });
    }
  }
  
  function initVideoCarousel() {
    const sections = document.querySelectorAll('.articles-podcasts-section');
    
    sections.forEach(function(section) {
      const slides = section.querySelectorAll('.ap-video-slide');
      const prevBtn = section.querySelector('.ap-video-prev');
      const nextBtn = section.querySelector('.ap-video-next');
      const dots = section.querySelectorAll('.ap-video-dot');
      
      if (slides.length === 0) {
        return;
      }
      
      let currentSlide = 0;
      let isTransitioning = false;
      let autoplayInterval;
      
      function showSlide(index, direction) {
        if (isTransitioning || index === currentSlide) return;
        
        isTransitioning = true;
        direction = direction || 'next';
        
        const currentSlideEl = slides[currentSlide];
        const nextSlideEl = slides[index];
        
        // Pause current video
        const currentVideo = currentSlideEl.querySelector('video');
        if (currentVideo) {
          currentVideo.pause();
        }
        
        // Hide current slide
        currentSlideEl.style.transition = 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)';
        currentSlideEl.style.opacity = '0';
        currentSlideEl.style.transform = direction === 'next' ? 'translateX(-100%)' : 'translateX(100%)';
        
        // Prepare next slide
        nextSlideEl.style.transition = 'none';
        nextSlideEl.style.transform = direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';
        nextSlideEl.style.opacity = '0';
        
        // Force reflow
        nextSlideEl.offsetHeight;
        
        // Animate in next slide
        setTimeout(function() {
          nextSlideEl.style.transition = 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)';
          nextSlideEl.style.opacity = '1';
          nextSlideEl.style.transform = 'translateX(0)';
          
          // Play next video after transition
          const nextVideo = nextSlideEl.querySelector('video');
          if (nextVideo) {
            setTimeout(function() {
              nextVideo.play().catch(function(e) {
                // Video autoplay might be prevented by browser policy
              });
            }, 300);
          }
        }, 50);
        
        // Update dots with proper styling
        dots.forEach(function(dot, i) {
          dot.classList.remove('ap-dot-active', 'bg-[#1E4036]', 'scale-125');
          dot.classList.add('bg-gray-400');
          if (i === index) {
            dot.classList.add('ap-dot-active', 'bg-[#1E4036]', 'scale-125');
            dot.classList.remove('bg-gray-400');
          }
        });
        
        currentSlide = index;
        
        setTimeout(function() {
          isTransitioning = false;
        }, 700);
        
        resetAutoplay();
      }
      
      function nextSlide() {
        const next = (currentSlide + 1) % slides.length;
        showSlide(next, 'next');
      }
      
      function prevSlide() {
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(prev, 'prev');
      }
      
      function startAutoplay() {
        if (slides.length > 1) {
          autoplayInterval = setInterval(nextSlide, 6000);
        }
      }
      
      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }
      
      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }
      
      // Event listeners
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          nextSlide();
        });
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          prevSlide();
        });
      }
      
      // Dot navigation
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          if (index !== currentSlide) {
            const direction = index > currentSlide ? 'next' : 'prev';
            showSlide(index, direction);
          }
        });
      });
      
      // Keyboard navigation
      section.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextSlide();
        }
      });
      
      // Touch support
      let startX = 0;
      let endX = 0;
      
      section.addEventListener('touchstart', function(e) {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      section.addEventListener('touchend', function(e) {
        endX = e.changedTouches[0].screenX;
        const diff = startX - endX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }, { passive: true });
      
      // Pause/resume autoplay on hover
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      
      // Pause autoplay when page is hidden
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          stopAutoplay();
        } else if (document.querySelector('.articles-podcasts-section:hover') === null) {
          startAutoplay();
        }
      });
      
      // Initialize first slide
      if (slides.length > 0) {
        slides[0].style.opacity = '1';
        slides[0].style.transform = 'translateX(0)';
        
        // Set first dot as active
        if (dots.length > 0) {
          dots[0].classList.add('ap-dot-active', 'bg-[#1E4036]', 'scale-125');
          dots[0].classList.remove('bg-gray-400');
        }
        
        // Play first video after a delay
        const firstVideo = slides[0].querySelector('video');
        if (firstVideo) {
          setTimeout(function() {
            firstVideo.play().catch(function(e) {
              // First video autoplay prevented
            });
          }, 1000);
        }
      }
      
      // Start autoplay
      startAutoplay();
    });
  }
  
  function initVideoControls() {
    const playButtons = document.querySelectorAll('.ap-play-btn');
    
    playButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const videoSlide = btn.closest('.ap-video-slide');
        const video = videoSlide ? videoSlide.querySelector('video') : null;
        
        if (video) {
          if (video.paused) {
            video.play().then(function() {
              btn.style.opacity = '0';
              btn.style.pointerEvents = 'none';
            }).catch(function(e) {
              // Video play failed
            });
          } else {
            video.pause();
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          }
        }
      });
    });
    
    // Video event listeners
    const videos = document.querySelectorAll('.ap-video-slide video');
    videos.forEach(function(video) {
      video.addEventListener('pause', function() {
        const playBtn = video.closest('.ap-video-slide').querySelector('.ap-play-btn');
        if (playBtn) {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
        }
      });
      
      video.addEventListener('play', function() {
        const playBtn = video.closest('.ap-video-slide').querySelector('.ap-play-btn');
        if (playBtn) {
          playBtn.style.opacity = '0';
          playBtn.style.pointerEvents = 'none';
        }
      });
      
      video.addEventListener('ended', function() {
        const playBtn = video.closest('.ap-video-slide').querySelector('.ap-play-btn');
        if (playBtn) {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
        }
        video.currentTime = 0;
      });
    });
  }
  
  function initArticleCards() {
    const cards = document.querySelectorAll('.article-card');
    
    cards.forEach(function(card) {
      // Enhanced hover effects
      card.addEventListener('mouseenter', function() {
        card.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        card.style.transform = 'translateY(-8px) scale(1.02)';
        card.style.boxShadow = '0 25px 50px rgba(0, 0, 0, 0.4)';
        card.style.background = 'rgba(255, 255, 255, 0.2)';
      });
      
      card.addEventListener('mouseleave', function() {
        card.style.transform = 'translateY(0) scale(1)';
        card.style.boxShadow = 'none';
        card.style.background = 'rgba(255, 255, 255, 0.1)';
      });
      
      // Click handling with ripple effect
      card.addEventListener('click', function(e) {
        const link = card.querySelector('a[href]');
        if (link && !e.target.closest('a')) {
          // Create ripple effect
          const ripple = document.createElement('div');
          const rect = card.getBoundingClientRect();
          const size = Math.max(rect.width, rect.height);
          
          ripple.style.cssText = `
            position: absolute;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            width: ${size}px;
            height: ${size}px;
            left: ${e.clientX - rect.left - size / 2}px;
            top: ${e.clientY - rect.top - size / 2}px;
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
            z-index: 1000;
          `;
          
          card.style.position = 'relative';
          card.style.overflow = 'hidden';
          card.appendChild(ripple);
          
          setTimeout(function() {
            if (link.href) {
              window.location.href = link.href;
            }
          }, 300);
          
          setTimeout(function() {
            if (ripple.parentNode) {
              ripple.remove();
            }
          }, 600);
        }
      });
    });
  }
  
  // Add required CSS animations
  function addAnimationStyles() {
    if (!document.querySelector('#articles-podcasts-animations')) {
      const style = document.createElement('style');
      style.id = 'articles-podcasts-animations';
      style.textContent = `
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        .articles-podcasts-section [data-aos] {
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .articles-podcasts-section [data-aos="fade-up"] {
          transform: translateY(50px);
          opacity: 0;
        }
        
        .articles-podcasts-section [data-aos="fade-right"] {
          transform: translateX(-50px);
          opacity: 0;
        }
        
        .articles-podcasts-section [data-aos="fade-left"] {
          transform: translateX(50px);
          opacity: 0;
        }
        
        .video-slide {
          will-change: transform, opacity;
        }
        
        .nav-arrow:focus,
        .play-btn:focus,
        .dot:focus {
          outline: 3px solid rgba(255, 255, 255, 0.8);
          outline-offset: 2px;
        }
      `;
      document.head.appendChild(style);
    }
  }
  
  // Initialize animations styles
  addAnimationStyles();
  
})();
